const STORAGE_KEY = 'kop-view-filters'

function parseStoredFilters() {
  if (typeof window === 'undefined') {
    return {}
  }

  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}')
  } catch (error) {
    console.warn('Failed to parse stored view filters', error)
    return {}
  }
}

function parseBoolean(value, fallback = true) {
  if (value === undefined || value === null || value === '') {
    return fallback
  }

  return value === true || value === 'true'
}

export function getViewFilters(route) {
  const storedFilters = parseStoredFilters()
  const query = route?.query || {}

  return {
    selectedVersion: query.version || storedFilters.version || null,
    isRanked: query.ranked === undefined ? parseBoolean(storedFilters.ranked, true) : query.ranked === 'true',
    versionExclusive:
      query.exclusive === undefined ? parseBoolean(storedFilters.exclusive, false) : query.exclusive === 'true',
  }
}

export function persistViewFilters(filters) {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      version: filters.selectedVersion || null,
      ranked: filters.isRanked,
      exclusive: filters.versionExclusive,
    })
  )
}

export function buildViewFiltersQuery(filters, fallbackVersion = null) {
  return {
    version: filters.selectedVersion || fallbackVersion || undefined,
    ranked: filters.isRanked ? 'true' : 'false',
    exclusive: filters.versionExclusive ? 'true' : 'false',
  }
}

export function hasViewFiltersChanged(currentFilters, nextFilters) {
  return (
    (currentFilters.selectedVersion || null) !== (nextFilters.selectedVersion || null) ||
    currentFilters.isRanked !== nextFilters.isRanked ||
    currentFilters.versionExclusive !== nextFilters.versionExclusive
  )
}
